import {Component, OnInit} from "@angular/core";
import {ApiService} from "../services/api.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {User} from "../models/user.model";
import {AuthServices} from "../services/auth.service";

@Component({
    selector: 'app-eat-drink-review',
    templateUrl: './eat-drink-review.component.html'
})
export class EatDrinkReviewComponent implements OnInit {
    restaurant: any;
    slug: string;
    reviewForm: FormGroup;
    reviewImages: Array<any>;
    files: FileList;
    auth_user: User;

    constructor(private api: ApiService,
                route: ActivatedRoute,
                private router: Router,
                fb: FormBuilder,
                private authService: AuthServices) {
        this.slug = route.snapshot.paramMap.get('slug');
        this.reviewForm = fb.group({
            'rating': [null, [Validators.required]],
            'title': [null, [Validators.required]],
            'review': [null, [Validators.required]],
            'year': ['', [Validators.required]],
            'month': ['', [Validators.required]],
            'sort': [null, [Validators.required]],
            'food': [null, [Validators.required]],
            'facilities': [null, [Validators.required]],
            'location': [null, [Validators.required]],
            'drink': [null, [Validators.required]],
            'service': [null, [Validators.required]],
            'money': [null, [Validators.required]],
            'confirmed': [true, [Validators.requiredTrue]],
        });
        this.reviewImages = [];
    }

    ngOnInit() {
        this.getAuthUser();
        this.getRestaurant();
        this.handleStarsChange();
    }

    onAddPhoto(event) {
        const self = this;
        this.files = event.target.files;

        for (let i = 0, f; f = this.files[i]; i++) {
            if (!f.type.match('image.*')) {
                // this.toasterService.pop('error', '', 'The picture must be a file of type: jpeg, jpg, png!');
                continue;
            }
            const reader = new FileReader();
            reader.onload = (function (file) {
                return function (e) {

                    file['style'] = {'background-image': `url(${e.target.result})`};
                    file['image'] = e.target.result;
                    self.reviewImages.push(file);

                    (<HTMLInputElement>document.getElementById('photos')).value = null;
                };
            })(f);
            reader.readAsDataURL(f);
        }
    }

    removeImage(index) {
        this.reviewImages.splice(index, 1);
        if (this.reviewImages.length === 0) {
            // this.projectForm.controls['image'].setValue(null);
        }
    }

    private getRestaurant(): void {
        this.api
            .getRestaurantBySlug(this.slug)
            .subscribe(
                res => {
                    if (res['results'].length) {
                        this.restaurant = res['results'][0];
                    } else {
                        this.router.navigateByUrl('/404');
                        return false;
                    }
                },
                err => console.log(err)
            );
    }

    private getAuthUser(): void {
        this.authService.currentUser.subscribe((user: User) => this.auth_user = user);
    }

    clickReview() {
        this.reviewForm['isSubmitted'] = true;
        if (this.reviewForm.valid) {
            const requestBody = {
                restaurant: this.restaurant.id,
                user: this.auth_user.id,
                rating: this.reviewForm.value.rating,
                title: this.reviewForm.value.title,
                review: this.reviewForm.value.review,
                date: this.reviewForm.value.year + '-' + this.reviewForm.value.month + '-01',
                food: this.reviewForm.value.food,
                facilities: this.reviewForm.value.facilities,
                location: this.reviewForm.value.location,
                service: this.reviewForm.value.service,
                drink: this.reviewForm.value.drink,
                money: this.reviewForm.value.money,
                sort: this.reviewForm.value.sort,
                images: this.reviewImages
            };


            this.api
                .postRestaurantReview(requestBody)
                .subscribe(
                    res => this.router.navigate(['/eat-and-drink', this.restaurant.categories.category_slug, this.restaurant.slug]),
                    err => console.log(err)
                );
        }
    }

    private handleStarsChange(): void {
        const self = this;
        $('.star-rating').on('rating:change', function (event, value) {
            const name = $(this).attr('id');
            console.log(name)
            console.log(self.reviewForm)
            self.reviewForm.get(name).setValue(value);
        });
    }
}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/eat-drink-review/eat-drink-review.component.ts